import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieConsent from "./components/CookieConsent";
import { usePageTracking } from "./lib/analytics";
import HomePage from "./pages/HomePage";
import NeighbourhoodsPage from "./pages/NeighbourhoodsPage";
import NeighbourhoodDetail from "./pages/NeighbourhoodDetail";
import BlueprintFlow from "./pages/BlueprintFlow";
import MatchResults from "./pages/MatchResults";
import LeadCapture from "./pages/LeadCapture";
import ThankYou from "./pages/ThankYou";
import { SchoolsPage, RelocationPage, BudgetPage } from "./pages/ContentPages";
import BurlingtonPage from "./pages/BurlingtonPage";
import BuyerBlueprintLanding from "./pages/BuyerBlueprintLanding";
import HomesForSale from "./pages/HomesForSale";
import ListingDetail from "./pages/ListingDetail";
import NeighbourhoodListings from "./pages/NeighbourhoodListings";
import { PrivacyPolicy, TermsOfService } from "./pages/LegalPages";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLeadList from "./pages/AdminLeadList";
import AdminLeadDetail from "./pages/AdminLeadDetail";
import AdminGuideList from "./pages/AdminGuideList";
import AdminGuideEditor from "./pages/AdminGuideEditor";
import AdminDripDashboard from "./pages/AdminDripDashboard";
import AdminDdfMonitor from "./pages/AdminDdfMonitor";
import GuidesIndex from "./pages/GuidesIndex";
import SEOPage from "./pages/SEOPage";
import { Toaster } from "./components/ui/sonner";

function AppRoutes() {
  usePageTracking();
  return (
    <>
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/burlington-on" element={<BurlingtonPage />} />
          <Route path="/burlington-buyer-blueprint" element={<BuyerBlueprintLanding />} />
          <Route path="/neighbourhoods" element={<NeighbourhoodsPage />} />
          <Route path="/neighbourhoods/:slug" element={<NeighbourhoodDetail />} />
          <Route path="/neighbourhoods/:slug/homes-for-sale" element={<NeighbourhoodListings />} />
          <Route path="/schools" element={<SchoolsPage />} />
          <Route path="/relocation" element={<RelocationPage />} />
          <Route path="/budget" element={<BudgetPage />} />
          <Route path="/guides" element={<GuidesIndex />} />
          <Route path="/guides/:slug" element={<SEOPage />} />
          <Route path="/homes-for-sale" element={<HomesForSale />} />
          <Route path="/listing/:mls" element={<ListingDetail />} />
          <Route path="/blueprint" element={<BlueprintFlow />} />
          <Route path="/results" element={<MatchResults />} />
          <Route path="/capture" element={<LeadCapture />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/ops" element={<Navigate to="/ops/dashboard" replace />} />
          <Route path="/ops/login" element={<AdminLogin />} />
          <Route path="/ops/dashboard" element={<AdminDashboard />} />
          <Route path="/ops/leads" element={<AdminLeadList />} />
          <Route path="/ops/leads/:id" element={<AdminLeadDetail />} />
          <Route path="/ops/guides" element={<AdminGuideList />} />
          <Route path="/ops/guides/new" element={<AdminGuideEditor />} />
          <Route path="/ops/guides/edit/:slug" element={<AdminGuideEditor />} />
          <Route path="/ops/drip" element={<AdminDripDashboard />} />
          <Route path="/ops/drip/:tab" element={<AdminDripDashboard />} />
          <Route path="/ops/ddf" element={<AdminDdfMonitor />} />
        </Routes>
      </main>
      <Footer />
      <CookieConsent />
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;
